import { Component, Inject, InjectionToken, OnInit } from '@angular/core';
import { IInjectedElementDtype } from '../../../models/InjectedElementDtype';
import { ProductCardService } from '../../../services/product-card.service';
import { MAX_MP_PRIORITY_VALUE } from '../../../../product/models/models';

import { SHARED_MODULES } from '../../../../shared.';

export const ELEMENT = new InjectionToken<any>('element', {
	providedIn: 'root',
	factory: () => 'element'
});

type ProductPositionDtypeElement = {
	position: number;
}

@Component({
    selector: 'app-product-position-dtype',
    templateUrl: './product-position-dtype.component.html',
    styleUrls: ['./product-position-dtype.component.scss'],
	imports: [SHARED_MODULES],
    standalone: true
})
export class ProductPositionDtypeComponent implements OnInit {

	public element: ProductPositionDtypeElement;
	public maxValue: number = MAX_MP_PRIORITY_VALUE

	constructor(
		@Inject(ELEMENT) private elementInjected: IInjectedElementDtype<ProductPositionDtypeElement>,
		private productCardService: ProductCardService
	) {}

	ngOnInit(): void {
		this.element = this.elementInjected.element;
	}

	public numberInputValidate(event: KeyboardEvent): boolean {
		const blockedSymbols: Array<string> = ['e', 'E', '-', '+', ',', '.'];
		return !blockedSymbols.includes(event.key);
	}

	public numberInputPasteValidate(event: ClipboardEvent) {
		const pasteData: string = event.clipboardData?.getData('text') || '';
		const blockedSymbols: Array<string> = ['e', 'E', '-', '+', ',', '.'];
		return blockedSymbols.every((symbol: string) => !pasteData.includes(symbol));
	}

	public onChange(event: Event): void {
		if (!event?.target) return;
		let value: number = Number((event.target as any).value);
		if (!value) value = null;
		(event.target as any).value = value;
		this.element.position = value;
		this.productCardService.updatePositionSubject.next({
			id: this.elementInjected.key,
			position: value
		});
	}

	public onInput(event: Event): void {
		const input = event.target as HTMLInputElement;
		if (+input.value > this.maxValue) input.value = String(this.maxValue);
	}
}
